(() => {
  const dialog = document.getElementById('wa-app-guide');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const triggers = [...document.querySelectorAll('[data-wa-app-open]')];
  const install = dialog.querySelector('[data-wa-app-install]');
  const status = dialog.querySelector('[data-wa-app-status]');
  const standalone = window.matchMedia('(display-mode: standalone)');
  let promptEvent = null;
  let opener = null;
  let installed = false;
  const syncTriggers = () => {
    const hide = installed || standalone.matches || window.navigator.standalone === true;
    triggers.forEach(trigger => { trigger.hidden = hide; });
    const footer = document.querySelector('.wa-app-footer');
    if (footer) footer.hidden = hide;
  };
  syncTriggers();
  standalone.addEventListener('change', syncTriggers);
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-wa-app-open]');
    if (!target) return;
    opener = target;
    if (!dialog.open) dialog.showModal();
  });
  dialog.querySelector('[data-wa-app-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (opener?.isConnected && !opener.hidden) opener.focus({preventScroll: true});
  });
  window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    promptEvent = event;
    install.hidden = false;
  });
  window.addEventListener('appinstalled', () => {
    installed = true;
    promptEvent = null;
    install.hidden = true;
    status.textContent = status.dataset.installed;
    syncTriggers();
  });
  install.addEventListener('click', async () => {
    if (!promptEvent) return;
    const currentPrompt = promptEvent;
    promptEvent = null;
    install.disabled = true;
    status.textContent = '';
    try {
      await currentPrompt.prompt();
      await currentPrompt.userChoice;
    } catch {
      status.textContent = status.dataset.retry;
    } finally {
      install.hidden = true;
      install.disabled = false;
    }
  });
})();
